import { render } from "./copyright-link.vue?vue&type=template&id=f7688922"
import script from "./copyright-link.vue?vue&type=script&lang=js"
export * from "./copyright-link.vue?vue&type=script&lang=js"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__